import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import { ossUploadByFormData } from '../../../../../../api/uploadAndDownload.js'
// import { uploadFiles } from '../../../../../../api/qualification.js'

export default {
    data() {
        return {
            pdfTransforming: false,
            form1: {
                id: '',
                // supplierCode: '',
                qualificationName: '',
                // certificateBeginDate: '',
                // certificateEndDate: '',
                fileName: '',
                fileUrl: '',
                fileId: '',
                qualificationTypeCode: '',
                qualificationType: '',
                // certificateNo: '',
                // uploadIdentityFront: '',
                // uploadIdentityBehind: '',
            },
        }
    },
    methods: {
        generateAndUploadPDF(fileName, callback) {
            this.pdfTransforming = true

            this.$nextTick(async () => {
                try {
                    // 1. 捕获DOM为图片
                    const element = this.$refs.contentRef
                    const canvas = await html2canvas(element, {
                        scale: 2, // 提高清晰度
                        // useCORS: true, // 允许跨域图片
                        // backgroundColor: "#FFFFFF" // 白色背景
                    })

                    // 2. 转换为PDF
                    const imgData = canvas.toDataURL('image/jpeg', 0.95)
                    const pdf = new jsPDF('p', 'mm', 'a4')
                    const pdfWidth = pdf.internal.pageSize.getWidth()
                    const pdfHeight = pdf.internal.pageSize.getHeight()

                    // // 计算图片在PDF中的尺寸（保持比例）
                    // const imgRatio = canvas.width / canvas.height
                    // const imgHeight = pdfHeight
                    // const imgWidth = imgHeight * imgRatio > pdfWidth ? pdfWidth : imgHeight * imgRatio
                    // // const imgWidth = pdfWidth

                    // 计算图片在PDF中的尺寸（保持比例）
                    const imgRatio = canvas.height / canvas.width
                    const imgWidth = pdfWidth * imgRatio > pdfHeight ? pdfHeight / imgRatio : pdfWidth
                    const imgHeight = imgWidth * imgRatio > pdfHeight ? pdfHeight : imgWidth * imgRatio
                    // 居中显示
                    const xPos = (pdfWidth - imgWidth) / 2

                    // pdf.addImage(imgData, 'JPEG', xPos, 10, imgWidth, imgHeight);
                    pdf.addImage(imgData, 'JPEG', xPos, 0, imgWidth, imgHeight)
                    const pdfBlob = pdf.output('blob')

                    // 3. 上传PDF
                    await this.uploadPDF(pdfBlob, fileName)
                    // await this.saveUpload()

                    this.pdfTransforming = false
                    // this.$message.success('PDF上传成功！')
                    callback && callback()
                } catch (error) {
                    console.error('生成/上传失败:', error)
                    this.pdfTransforming = false
                    // this.$message.warning('操作失败，请查看控制台')
                }
            })
        },
        uploadPDF(blob, fileName) {
            const formData = new FormData()
            formData.append('file', blob, fileName)

            // 替换为你的API地址
            return ossUploadByFormData(formData, { bucket: 'srm', publicRead: 1, businessKey: '' }).then(res => {
                if (res && +res.code === 0) {
                    // console.log(res.data)
                    // const a = document.createElement('a')
                    // a.href = res.data.downUrl
                    // a.click()

                    this.form1.fileId = new Date().getTime()
                    this.form1.fileName = fileName
                    this.form1.fileUrl = res.data.downUrl
                }
            })
        },
        // saveUpload() {
        //     uploadFiles(this.getParamsFromUpload()).then(res => {
        //         if (res && +res.code === 0) {
        //             // this.$message.success('上传成功')
        //             // this.handleClose();
        //             // this.search();
        //         }
        //     })
        // },
        getParamsFromUpload() {
            const params = JSON.parse(JSON.stringify(this.form1))
            params.fileId = this.form1.fileId
            params.fileName = this.form1.fileName
            params.fileUrl = this.form1.fileUrl
            return params
        },
        setUploadQlfForm(data) {
            // this.form1.fileName = data.data.data.localFileName;
            // this.form1.fileUrl = data.data.data.downUrl;
            // this.form1.fileId = data.data.data.id;
            this.form1.id = data.id
            this.form1.qualificationType = data.qualificationType
            this.form1.qualificationTypeCode = data.qualificationTypeCode
            // this.form1.supplierCode = data.supplierCode
            this.form1.qualificationName = data.qualificationName
        },
    },
}
